import { reject } from "bluebird";
const UL_CHARS = ["-", "*"]

const convertChatMessageToHtml=(value, messageFromOther)=>{
    try{
        var lines = value.split(/\n/g);
        // console.log('lines:', lines);
        var res=""
        var currLine
        var prevLine
        var nextLine
        // var urlIncluded=false
        // var lastUrl
    
        for (let i = 0; i < lines.length; i++) {
            prevLine = getLine(lines, i-1)
            currLine = urlify(getLine(lines, i), messageFromOther)
            nextLine = getLine(lines, i+1)

            // var urlifiedRes = urlify(currLine)
            // console.log('urlifiedRes:', urlifiedRes);

            // if(urlifiedRes.url){
            //     console.log('urlifiedRes.url:', urlifiedRes.url);
                
            //     lastUrl=urlifiedRes.url;
            //     currLine = urlifiedRes.urlified;
            // } 
            
            if(lineHasUlStart(currLine)){
                res+=getUlItem(prevLine, currLine, nextLine)
            } 
            else {
                // current line is not list, 
                //if(lineHasUlStart(prevLine)) res+=getParagraph(currLine) //previous was, new paragraph to start
                res += getBreakLine(currLine)                                     // previous was not, continue
            }
        }

        // if(lastUrl) res +="<iframe src="+lastUrl+"></iframe>"
        return res
    }catch(ex){
        console.error('ex:', ex);
        return "<p>"+value+"</p>"
    }
}
let getBreakLine=(line)=>{
    if(line) return line+"</br>"
    else return ""
}
let getLine=(lines, index)=>{
    if(index < 0) return ""
    else if(index <= lines.length-1) return lines[index]
    else return ""
}

let getParagraph=(line)=>{
    if(line) return "<p>"+line+"</p>"
    else return ""
}

let getUlItem=(prevLine, currLine, nextLine)=>{
    // start <ul> or add <li>
    var res = ""
    var lineWithUlStarts = currLine.replace(UL_CHARS[0], "")
    lineWithUlStarts = lineWithUlStarts.replace(UL_CHARS[1], "")

    if(lineHasUlStart(prevLine)) res+="<li>" + lineWithUlStarts + "</li>"
    else res += "<ul><li>"+ lineWithUlStarts +"</li>"

    // end </ul> if needed
    if(!lineHasUlStart(nextLine))res+="</ul>" 
    
    return res
}

let lineHasUlStart=(line)=>{
    return (line && UL_CHARS.includes(line.charAt(0)) && line.charAt(1) === " ")
}

let urlify=(text, messageFromOther)=> {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    // var matches = text.match(urlRegex);  // creates array from matches
    // if(matches && matches.length > 0) return {url: matches[0], urlified: '<a style="color:white; text-decoration: underline" href="' + matches[0] + '" target="_blank">' + matches[0] + '</a>'}
    // else return text

    return text.replace(urlRegex, function(url) {
        // styling is done here cause dynamically added html doesn't follow predefiend css rules
        var r
        messageFromOther?
        r='<a style="text-decoration: underline" href="' + url + '" target="_blank">' + url + '</a>':
        r='<a style="color:white; text-decoration: underline" href="' + url + '" target="_blank">' + url + '</a>';
        return r 
    })
}


export {convertChatMessageToHtml}




// WEBPACK FOOTER //
// ./src/platform/chat/utils/chatInputHelper.js